import { useNavigate } from "react-router-dom";

import {
    Card,
    CardHeader,
    CardTitle,
    CardBody,
    Button
} from "reactstrap"

function Forbidden () {
    const navigation = useNavigate();

    return (
        <>
            <div className="content">
                <Card>
                    <CardHeader>
                        <CardTitle tag="h4"></CardTitle>
                    </CardHeader>
                    <CardBody>
                        <div className="typography-line">
                            <h1 className="title">Goodnet</h1>
                            <h6>Anda Tidak memiliki Akses untuk Halaman Ini</h6>
                            <p>403 Forbidden</p>
                            <Button
                                size="lg"
                                className="mb-3 btn-round text-white font-weight-bold bg-dark"
                                onClick={() => navigation('/')}
                            >Kembali</Button>
                        </div>
                    </CardBody>
                </Card>
            </div>
        </>
    )
}

export default Forbidden